import {
    getMethod,
    deleteMethod
} from "../../api-service/api-service";

import {
    setPortalUsers,
    setPagination,
    setSelectedPortalUser,
    removePortalUser,
    setLoading
} from "./portalUserSlice";

/* GET ALL USERS */

export const fetchPortalUsers = (filters = {}) => async (dispatch) => {

    try {

        dispatch(setLoading(true));

        const query = new URLSearchParams(filters).toString();

        const res = await getMethod(`/user/list?${query}`);

        if (res?.success) {
            dispatch(setPortalUsers(res.data));
            dispatch(setPagination(res.pagination));
        }

        dispatch(setLoading(false));

        return res;

    } catch (err) {

        dispatch(setLoading(false));

        console.log(err);

        return {
            success: false
        };
    }

};


/* GET USER DETAILS */

export const fetchPortalUserDetails = (id) => async (dispatch) => {

    const res = await getMethod(`/user/${id}`);

    if (res?.success) {
        dispatch(setSelectedPortalUser(res.user));
    }

    return res;
};


/* DELETE USER */

export const deletePortalUser = (id) => async (dispatch) => {

    const res = await deleteMethod(`/user/${id}`);

    if (res?.success) {
        dispatch(removePortalUser(id));
    }

    return res;
};